<template>
  <div class="main__pre-post-arrangement container main--sticky-bottom">
    <el-collapse ref="formRoot" v-model="activeCollapseIndexes">
      <el-collapse-item
        v-for="(contact, index) in contacts"
        :key="contact.contactID"
        :class="{
          'el-collapse-item--prePostArrangement--samePlan':
            contact.hasSamePrePostArrangement,
        }"
        :name="index"
        class="el-collapse-item--prePostArrangement"
      >
        <div class="label-mandatory">Fields marked with * are mandatory</div>
        <template slot="title" class="title">
          <span class="guest-number">GUEST {{ index + 1 }} / </span>
          {{ getFullName(contact) }}

          <el-checkbox
            v-if="contact.contactID !== primaryContact.contactID"
            :value="contact.hasSamePrePostArrangement"
            class="checkbox--samePlan"
            @input="
              onCheckHasSamePlan(
                contact.contactID,
                primaryContact.contactID,
                'hasSamePrePostArrangement',
                $event,
              )
            "
          >
            Same plan as Guest 1
          </el-checkbox>
        </template>
        <div>
          <el-row justify="space-between" type="flex">
            <div class="section-title">
              {{
                booking.isGalapagosCruise
                  ? "Arrival to Galapagos"
                  : "Pre-cruise"
              }}
            </div>
          </el-row>

          <scope
            :preArrangement="
              preArrangementByContactIDAndCategory(contact.contactID, 'Flight')
            "
            tag="div"
          >
            <template
              v-if="
                preArrangement &&
                preArrangement.flightBookedByAqua &&
                booking.facilityCode === 'AQM'
              "
              slot-scope="{ preArrangement }"
            >
              <el-row>
                Aqua expeditions has partnered with LATAM Airlines to offer
                preferential rates on flights from Quito or Guayaquil which
                arrive on the day of Aqua Mare’s departure. Our Guest Relations
                Coordinator will reach out to coordinate the details of your
                flights.
              </el-row>
              <div class="note" style="margin-top: 0">
                If you want to make any changes or arrange your own flights,
                please reach out to
                <a
                  href="mailto:reservations@aquaexpeditions.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  >reservations@aquaexpeditions.com</a
                >
              </div>
            </template>
          </scope>

          <scope
            :preArrangement="
              preArrangementByContactIDAndCategory(contact.contactID, 'Flight')
            "
            tag="div"
            :forms="forms"
          >
            <template
              v-if="preArrangement && !preArrangement.flightBookedByAqua"
              slot-scope="{ preArrangement }"
            >
              <el-row v-if="booking.recommendedFlight">
                <el-col :span="16">
                  <div class="recommended-flight">
                    <ae-error-wrapper
                      error-message="This is a required field"
                      :is-error="
                        forms[contact.contactID].preArrangements
                          .takingRecommendedFlight
                      "
                      ref="ae-error-wrapper-field"
                    >
                      <template v-slot:form-item>
                        <el-checkbox
                          :value="preArrangement.takingRecommendedFlight"
                          class="check-row"
                          @input="
                            onPreArrangementInputChange(
                              preArrangement.preArrangementID,
                              'takingRecommendedFlight',
                              !preArrangement.takingRecommendedFlight,
                            )
                          "
                        >
                          I am on the recommended flight
                        </el-checkbox>
                      </template>
                    </ae-error-wrapper>
                    <div
                      :class="{
                        hidden: !preArrangement.takingRecommendedFlight,
                      }"
                      class="recommended-flight__detail"
                    >
                      <!--DepartureDate               2-FEB-18-->
                      <!--ArrivalDate                 5-FEB-18-->
                      <!--Ship                        ARIA-->
                      <!--Nights                      3-->
                      <!--OutboundFlightFrom          LIM-->
                      <!--OutboundFlightTo            IQT-->
                      <!--OutboundFlightCode          LAN2236-->
                      <!--OutboundFlightDepartureTime 17:35-->
                      <!--OutboundFlightArrivalTime   19:25-->
                      <!--ReturnFlightFrom            IQT-->
                      <!--ReturnFlightTo              LIM-->
                      <!--ReturnFlightCode            LAN2241-->
                      <!--ReturnFlightDepartureTime   13:00-->
                      <!--ReturnFlightArrivalTime     14:45-->

                      <div class="flight__departure">
                        <div class="code">
                          {{ booking.recommendedFlight.outboundFlightFrom }}
                        </div>
                        <div class="city">
                          {{ booking.recommendedFlight.outboundFlightFromText }}
                        </div>
                        <div class="time">
                          {{
                            booking.recommendedFlight
                              .outboundFlightDepartureTime
                          }}
                        </div>
                      </div>

                      <div class="flight__arrival">
                        <div class="code">
                          {{ booking.recommendedFlight.outboundFlightTo }}
                        </div>
                        <div class="city">
                          {{ booking.recommendedFlight.outboundFlightToText }}
                        </div>
                        <div class="time">
                          {{
                            booking.recommendedFlight.outboundFlightArrivalTime
                          }}
                        </div>
                      </div>

                      <div class="flight__number">
                        <div class="label">Flight</div>
                        <div class="value">
                          {{ booking.recommendedFlight.outboundFlightCode }}
                        </div>
                      </div>

                      <div class="flight__date">
                        <div class="label">Date</div>
                        <div class="value">
                          {{ booking.recommendedFlight.departureDateDisplay }}
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row
                v-else-if="booking.isGalapagosCruise"
                class="arrive-by__label"
              >
                I will arrive by airplane to Galapagos.
              </el-row>
              <el-row
                v-else-if="booking.isFromTanzania"
                class="arrive-by__label"
              >
                I will arrive by airplane into:
                <el-form :model="preArrangement">
                  <el-radio-group
                    :value="
                      preArrangement.zanzibarAirport === true ? true : false
                    "
                    class="tanzania-flight"
                    @input="
                      onPreArrangementInputChange(
                        preArrangement.preArrangementID,
                        'zanzibarAirport',
                        $event,
                      )
                    "
                  >
                    <el-radio :label="true">
                      <div>
                        Zanzibar (Abeid Amani Karuma International Airport
                        (ZNZ))
                      </div>
                    </el-radio>
                    <el-radio
                      :label="false"
                      class="tanzania-flight__other-airport"
                      ><div class="tanzania-flight__other-airport">
                        Tanzania Other airport:

                        <div>
                          <ae-error-wrapper
                            ref="ae-error-wrapper-field"
                            error-message="This is a required field"
                            :is-error="
                              forms[contact.contactID].preArrangements
                                .otherAirport
                            "
                          >
                            <template v-slot:form-item>
                              <el-input
                                :value="preArrangement.otherAirport"
                                placeholder="other airport name"
                                style="width: auto; margin-top: 0px"
                                @input="
                                  onPreArrangementInputChange(
                                    preArrangement.preArrangementID,
                                    'otherAirport',
                                    $event,
                                  )
                                "
                              ></el-input>
                            </template>
                          </ae-error-wrapper>
                        </div></div
                    ></el-radio>
                  </el-radio-group>
                </el-form>
              </el-row>
              <el-row v-else>
                <ae-error-wrapper
                  ref="ae-error-wrapper-field"
                  error-message="This is a required field"
                  :is-error="
                    forms[contact.contactID].preArrangements.notTakingAFlight
                  "
                >
                  <template v-slot:form-item>
                    <el-checkbox
                      :value="!preArrangement.notTakingAFlight"
                      @input="
                        onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'notTakingAFlight',
                          !$event,
                        )
                      "
                    >
                      {{
                        booking.isAmazonCruise
                          ? "I am taking a flight to Iquitos."
                          : booking.departurePort === "Komodo National Park"
                            ? "I will arrive by airplane to Labuan Bajo"
                            : `I will arrive by airplane to ${booking.departurePort}.`
                      }}
                    </el-checkbox>
                  </template>
                </ae-error-wrapper>
              </el-row>

              <el-row
                v-if="
                  (booking.recommendedFlight &&
                    !preArrangement.takingRecommendedFlight) ||
                  (!booking.recommendedFlight &&
                    !preArrangement.notTakingAFlight)
                "
                style="margin-top: 24px"
              >
                I will arrive on

                <ae-error-wrapper
                  ref="ae-error-wrapper-field"
                  error-message="This is a required field"
                  :is-error="
                    forms[contact.contactID].preArrangements.arrivalDate
                  "
                >
                  <template v-slot:form-item>
                    <el-date-picker
                      :value="preArrangement.arrivalDate"
                      format="yyyy-MM-dd"
                      placeholder="Select date*"
                      type="date"
                      value-format="yyyy-MM-dd"
                      @input="
                        onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'arrivalDate',
                          $event,
                        )
                      "
                    />
                  </template>
                </ae-error-wrapper>
                <ae-error-wrapper
                  ref="ae-error-wrapper-field"
                  error-message="This is a required field"
                  :is-error="
                    forms[contact.contactID].preArrangements.arrivalTime
                  "
                >
                  <template v-slot:form-item>
                    <el-time-picker
                      :value="preArrangement.arrivalTime"
                      format="HH:mm"
                      placeholder="Select time*"
                      value-format="HH:mm"
                      @input="
                        onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'arrivalTime',
                          $event,
                        )
                      "
                    />
                  </template>
                </ae-error-wrapper>

                on flight number
                <ae-error-wrapper
                  ref="ae-error-wrapper-field"
                  error-message="Please enter your post-cruise flight number."
                  :is-error="
                    forms[contact.contactID].preArrangements.flightNumber
                  "
                >
                  <template v-slot:form-item>
                    <el-input
                      :value="preArrangement.flightNumber"
                      placeholder="your flight number*"
                      style="width: auto"
                      @input="
                        onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'flightNumber',
                          $event,
                        )
                      "
                    >
                      <template #suffix>
                        <div class="info-flight-number-wrapper">
                          <el-popover
                            content="You will find your flight number in the flight confirmation : eg 'XX 1234' or 'YY 123'."
                            placement="top"
                            trigger="hover"
                            width="200"
                          >
                            <span slot="reference"
                              ><i class="icon icon-information"></i
                            ></span>
                          </el-popover></div
                      ></template>
                    </el-input>
                  </template>
                </ae-error-wrapper>
                <div style="display: flex; align-items: center">
                  <br />coming from

                  <ae-error-wrapper
                    ref="ae-error-wrapper-field"
                    error-message="This is a required field"
                    :is-error="forms[contact.contactID].preArrangements.from"
                  >
                    <template v-slot:form-item>
                      <el-input
                        :value="preArrangement.from"
                        placeholder="place"
                        style="width: auto; margin-top: 24px"
                        @input="
                          onPreArrangementInputChange(
                            preArrangement.preArrangementID,
                            'from',
                            $event,
                          )
                        "
                      ></el-input>
                    </template>
                  </ae-error-wrapper>
                  <div v-if="booking.isAquaLares">
                    via

                    <ae-error-wrapper
                      ref="ae-error-wrapper-field"
                      error-message="This is a required field"
                      :is-error="
                        forms[contact.contactID].preArrangements.airline
                      "
                    >
                      <template v-slot:form-item>
                        <el-input
                          :value="preArrangement.airline"
                          placeholder="airline"
                          style="width: auto; margin-top: 24px"
                          @input="
                            onPreArrangementInputChange(
                              preArrangement.preArrangementID,
                              'airline',
                              $event,
                            )
                          "
                        ></el-input>
                      </template>
                    </ae-error-wrapper>
                  </div>
                </div>
                <!--<div class="note">You find your flight number in the flight confirmation : eg 'XX 1234' or 'YY 123'.</div>-->
              </el-row>
            </template>
          </scope>

          <scope
            v-if="booking.isGalapagosCruise"
            :preArrangement="
              preArrangementByContactIDAndCategory(contact.contactID, 'Flight')
            "
            tag="el-row"
            :forms="forms"
          >
            <template
              v-if="
                preArrangement &&
                !preArrangement.flightBookedByAqua &&
                ((preArrangement.flightNumber && preArrangement.arrivalDate) ||
                  preArrangement.galapagosRouteInfo)
              "
              slot-scope="{ preArrangement }"
            >
              <div>
                I will be embarking from
                <ae-error-wrapper
                  ref="ae-error-wrapper-field"
                  error-message="This is a required field"
                  :is-error="
                    forms[contact.contactID].preArrangements.galapagosRouteInfo
                  "
                >
                  <template v-slot:form-item>
                    <v-select
                      :ref="'preArrangementTypeSelect' + contact.contactID"
                      :clearable="false"
                      :options="selectTypeOfRouteToGalapagos"
                      :reduce="(item) => item.value"
                      :searchable="false"
                      :value="preArrangement.galapagosRouteInfo"
                      placeholder="your departure and arrival city*"
                      filterable
                      label="label"
                      style="
                        width: 440px;
                        display: inline-block;
                        vertical-align: middle;
                        font-size: 18px;
                      "
                      @input="
                        onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'galapagosRouteInfo',
                          $event,
                        )
                      "
                    >
                    </v-select>
                  </template>
                </ae-error-wrapper>
              </div>
            </template>
          </scope>
          <scope
            v-else
            :preArrangement="
              preArrangementByContactIDAndCategory(
                contact.contactID,
                'Location to port',
              )
            "
            tag="el-row"
            :forms="forms"
          >
            <template v-if="preArrangement" slot-scope="{ preArrangement }">
              <div>
                <div class="arrangement-field">
                  <span v-if="booking.isAquaLares">
                    I plan to transfer to the meeting point by
                  </span>
                  <span v-else>I plan to go to the port by</span>
                  <ae-error-wrapper
                    ref="ae-error-wrapper-field"
                    error-message="This is a required field"
                    :is-error="
                      forms[contact.contactID].preArrangements
                        .typeOfPreCruiseArrangement
                    "
                  >
                    <template v-slot:form-item>
                      <v-select
                        :ref="'preArrangementTypeSelect' + contact.contactID"
                        :clearable="false"
                        :options="selectTypeOfArrangementsForPreCruise(contact)"
                        :reduce="(item) => item.value"
                        :searchable="false"
                        :value="preArrangement.typeOfArrangement"
                        placeholder="select option*"
                        filterable
                        label="label"
                        style="
                          width: 440px;
                          display: inline-block;
                          vertical-align: middle;
                        "
                        @input="
                          onPreArrangementInputChange(
                            preArrangement.preArrangementID,
                            'typeOfArrangement',
                            $event,
                          )
                        "
                      >
                      </v-select>
                    </template>
                  </ae-error-wrapper>
                </div>
              </div>

              <div
                v-if="
                  preArrangement.typeOfArrangement &&
                  preArrangement.typeOfArrangement.indexOf(
                    'AE Private transfer',
                  ) === 0 &&
                  booking.preArrangementPrivateTransferNote
                "
                class="note"
                v-html="
                  formatTransferNote(booking.preArrangementPrivateTransferNote)
                "
              ></div>
              <div
                v-if="
                  preArrangement.typeOfArrangement === 'AE Shared transfer' &&
                  booking.preArrangementSharedTransferNote
                "
                class="note"
              >
                {{ booking.preArrangementSharedTransferNote }}
              </div>
              <div
                v-if="
                  preArrangement.typeOfArrangement &&
                  preArrangement.typeOfArrangement.indexOf(
                    'AE Private transfer',
                  ) === 0 &&
                  booking.preArrangementPrivateTransferLink
                "
                class="note"
              >
                Please contact us at
                <a
                  href="mailto:reservations@aquaexpeditions.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  >reservations@aquaexpeditions.com</a
                >
                to arrange your private transfer. Kindly note that this service
                is available at an additional cost.
              </div>
              <!--              <div v-else-if="preArrangement.typeOfArrangement && preArrangement.typeOfArrangement.indexOf('AE Private transfer') === 0 && booking.preArrangementPrivateTransferLink" class="note">Note:  Please refer to the price list and additional information for Aqua Expeditions’ private transfers <a :href="booking.preArrangementPrivateTransferLink" target="_blank">here</a>.</div>-->
              <div v-if="preArrangement.typeOfArrangement === 'By 3rd party'">
                <div style="margin-top: 24px; margin-bottom: 16px">
                  <span style="display: inline-block"
                    >Driver contact details</span
                  >
                  <ae-error-wrapper
                    error-message="This is a required field"
                    :is-error="
                      forms[contact.contactID].preArrangements.localHandler
                    "
                    ref="ae-error-wrapper-field"
                  >
                    <template v-slot:form-item>
                      <el-input
                        :value="preArrangement.localHandler"
                        placeholder="local handler's name*"
                        style="width: auto"
                        @input="
                          onPreArrangementInputChange(
                            preArrangement.preArrangementID,
                            'localHandler',
                            $event,
                          )
                        "
                      ></el-input>
                    </template>
                  </ae-error-wrapper>
                  <ae-error-wrapper
                    error-message="This is a required field"
                    :is-error="
                      forms[contact.contactID].preArrangements.nameOfPerson
                    "
                    ref="ae-error-wrapper-field"
                  >
                    <template v-slot:form-item>
                      <el-input
                        :value="preArrangement.nameOfPerson"
                        placeholder="driver name*"
                        style="width: auto"
                        @input="
                          onPreArrangementInputChange(
                            preArrangement.preArrangementID,
                            'nameOfPerson',
                            $event,
                          )
                        "
                      ></el-input>
                    </template>
                  </ae-error-wrapper>
                  <ae-error-wrapper
                    error-message="This is a required field"
                    :is-error="
                      forms[contact.contactID].preArrangements.contactNo
                    "
                    ref="ae-error-wrapper-field"
                  >
                    <template v-slot:form-item>
                      <el-input
                        :value="preArrangement.contactNo"
                        placeholder="contact number*"
                        style="width: auto"
                        @input="
                          onPreArrangementInputChange(
                            preArrangement.preArrangementID,
                            'contactNo',
                            $event,
                          )
                        "
                      ></el-input>
                    </template>
                  </ae-error-wrapper>
                </div>
                <div class="arrangement-field">
                  <span style="display: inline-block">from</span>
                  <ae-error-wrapper
                    ref="ae-error-wrapper-field"
                    error-message="This is a required field"
                    :is-error="forms[contact.contactID].preArrangements.from"
                  >
                    <template v-slot:form-item>
                      <el-input
                        :value="preArrangement.from"
                        placeholder="pick up location"
                        style="width: 440px"
                        @input="
                          onPreArrangementInputChange(
                            preArrangement.preArrangementID,
                            'from',
                            $event,
                          )
                        "
                      ></el-input>
                    </template>
                  </ae-error-wrapper>
                </div>
              </div>
              <div
                v-if="preArrangement.typeOfArrangement === 'Other'"
                class="arrangement-field"
                style="display: flex; margin-top: 24px"
              >
                <ae-error-wrapper
                  ref="ae-error-wrapper-field"
                  error-message="This is a required field"
                  :is-error="forms[contact.contactID].preArrangements.otherMode"
                >
                  <template v-slot:form-item>
                    <el-input
                      :value="preArrangement.otherMode"
                      placeholder="other modes"
                      style="width: 440px"
                      @input="
                        onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'otherMode',
                          $event,
                        )
                      "
                    ></el-input>
                  </template>
                </ae-error-wrapper>
              </div>
              <div
                v-if="
                  (preArrangement.typeOfArrangement === 'By 3rd party' ||
                    preArrangement.typeOfArrangement === 'Taxi' ||
                    preArrangement.typeOfArrangement === 'Other') &&
                  booking.preArrangementOtherTransferNote
                "
                class="note"
              >
                {{ booking.preArrangementOtherTransferNote }}
              </div>
              <div
                v-if="
                  booking.isAquaLares &&
                  booking.departurePort === 'Madagascar' &&
                  isCurrentDateBefore(2026, 1, 15)
                "
                class="note"
                style="display: flex"
              >
                Please arrive on 14th February, as departure is at 9:00 AM on
                15th February.
              </div>
              <br />
              <div
                v-if="canShowDateOfEntryToPeruField(contact)"
                style="margin-top: 24px; margin-bottom: 16px"
              >
                <el-row>
                  Date of entry to Peru
                  <ae-error-wrapper
                    ref="ae-error-wrapper-field"
                    error-message="This is a required field"
                    :is-error="
                      forms[contact.contactID].preArrangements.dateOfEntryToPeru
                    "
                  >
                    <template v-slot:form-item>
                      <el-date-picker
                        :value="preArrangement.dateOfEntryToPeru"
                        format="yyyy-MM-dd"
                        placeholder="Select date*"
                        type="date"
                        value-format="yyyy-MM-dd"
                        @input="
                          onPreArrangementInputChange(
                            preArrangement.preArrangementID,
                            'dateOfEntryToPeru',
                            $event,
                          )
                        "
                      />
                    </template>
                  </ae-error-wrapper>
                  from
                  <ae-error-wrapper
                    ref="ae-error-wrapper-field"
                    error-message="This is a required field"
                    :is-error="
                      forms[contact.contactID].preArrangements.entryToPeruFrom
                    "
                  >
                    <template v-slot:form-item>
                      <v-select
                        :clearable="false"
                        :filter-by="filterCountry"
                        :options="selectCountries"
                        :reduce="(item) => item.value"
                        :value="preArrangement.entryToPeruFrom"
                        placeholder="select option*"
                        filterable
                        label="label"
                        style="
                          min-width: 420px;
                          display: inline-block;
                          vertical-align: middle;
                        "
                        @input="
                          onPreArrangementInputChange(
                            preArrangement.preArrangementID,
                            'entryToPeruFrom',
                            $event,
                          )
                        "
                        @visible-change="resetFilterCountry"
                      >
                      </v-select>
                    </template>
                  </ae-error-wrapper>
                </el-row>
              </div>
            </template>
          </scope>
          <!-- 20250408: Request by client to include accommodation for AQM and AQB
          Removed check for: v-if="!booking.isGalapagosCruise && booking.facilityCode !== 'AQB'" -->
          <scope
            :preArrangement="
              preArrangementByContactIDAndCategory(
                contact.contactID,
                'Accommodation',
              )
            "
            tag="el-row"
            :forms="forms"
          >
            <template v-if="preArrangement" slot-scope="{ preArrangement }">
              <el-row>
                <ae-error-wrapper
                  ref="ae-error-wrapper-field"
                  error-message="This is a required field"
                  :is-error="
                    forms[contact.contactID].preArrangements.arrivePriorToCruise
                  "
                >
                  <template v-slot:form-item>
                    <el-checkbox
                      :value="preArrangement.arrivePriorToCruise"
                      @input="
                        onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'arrivePriorToCruise',
                          $event,
                        )
                      "
                    >
                      I plan to arrive the day prior to the cruise.
                    </el-checkbox>
                  </template>
                </ae-error-wrapper>
              </el-row>
              <el-row
                v-if="canShowPreArrangementAccommodationField(contact)"
                style="margin-top: 24px"
              >
                <div
                  class="arrangement-field"
                  v-if="booking.isAquaLares"
                  style="margin-bottom: 24px"
                >
                  I plan to arrive
                  <ae-error-wrapper
                    ref="ae-error-wrapper-field"
                    error-message="This is a required field"
                    :is-error="
                      forms[contact.contactID].preArrangements.daysBefore
                    "
                  >
                    <template v-slot:form-item>
                      <el-input
                        :value="preArrangement.daysBefore"
                        placeholder="number of days*"
                        style="width: 200px"
                        @input="
                          onPreArrangementInputChange(
                            preArrangement.preArrangementID,
                            'daysBefore',
                            $event,
                          )
                        "
                      />
                    </template>
                  </ae-error-wrapper>
                  days prior to cruise departure
                </div>
                <div class="arrangement-field">
                  I will be staying at
                  <ae-error-wrapper
                    ref="ae-error-wrapper-field"
                    error-message="This is a required field"
                    :is-error="
                      forms[contact.contactID].preArrangements.accommodationName
                    "
                  >
                    <template v-slot:form-item>
                      <el-input
                        :value="preArrangement.accommodationName"
                        placeholder="name of your accommodation*"
                        style="width: 500px"
                        @input="
                          onPreArrangementInputChange(
                            preArrangement.preArrangementID,
                            'accommodationName',
                            $event,
                          )
                        "
                      />
                    </template>
                  </ae-error-wrapper>
                </div>
              </el-row>
            </template>
          </scope>
        </div>
        <div
          v-if="booking.isGalapagosCruise"
          class="note"
          style="margin-top: 0"
        >
          All transfers to the port will be arranged by Aqua Expeditions and are
          shared.
        </div>
        <hr />
        <div>
          <el-row justify="space-between" type="flex">
            <div class="section-title">
              {{
                booking.isGalapagosCruise
                  ? "Departure from Galapagos"
                  : "Post-cruise"
              }}
            </div>
          </el-row>

          <scope
            :postArrangement="
              postArrangementByContactIDAndCategory(contact.contactID, 'Flight')
            "
            tag="div"
          >
            <template
              v-if="
                postArrangement &&
                postArrangement.flightBookedByAqua &&
                booking.facilityCode === 'AQM'
              "
              slot-scope="{ postArrangement }"
            >
              <el-row>
                Aqua expeditions has partnered with LATAM Airlines to offer
                preferential rates on flights from Quito or Guayaquil which
                arrive on the day of Aqua Mare’s departure. Our Guest Relations
                Coordinator will reach out to coordinate the details of your
                flights.
              </el-row>
              <div class="note" style="margin-top: 0">
                If you want to make any changes or arrange your own flights,
                please reach out to
                <a
                  href="mailto:reservations@aquaexpeditions.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  >reservations@aquaexpeditions.com</a
                >
              </div>
            </template>
          </scope>

          <scope
            v-if="!booking.isGalapagosCruise"
            :postArrangement="
              postArrangementByContactIDAndCategory(
                contact.contactID,
                'Port to location',
              )
            "
            tag="el-row"
            :forms="forms"
          >
            <template v-if="postArrangement" slot-scope="{ postArrangement }">
              <span class="bold" style="vertical-align: middle"
                >When the cruise ends,</span
              >

              <span style="vertical-align: middle">I plan to</span>
              <ae-error-wrapper
                ref="ae-error-wrapper-field"
                error-message="Please specify your post-cruise transportation details."
                :is-error="
                  forms[contact.contactID].postArrangements
                    .postArrangementAction
                "
              >
                <template v-slot:form-item>
                  <v-select
                    :ref="'postArrangementActionSelect' + contact.contactID"
                    :clearable="false"
                    :options="selectPostArrangementActions()"
                    :reduce="(item) => item.value"
                    :searchable="false"
                    :value="postArrangement.postArrangementAction"
                    placeholder="select option"
                    filterable
                    label="label"
                    style="
                      width: 540px;
                      display: inline-block;
                      vertical-align: middle;
                    "
                    @input="
                      onPostArrangementInputChange(
                        postArrangement.postArrangementID,
                        'postArrangementAction',
                        $event,
                      )
                    "
                  >
                  </v-select>
                </template>
              </ae-error-wrapper>
              <br />
            </template>
          </scope>

          <scope
            v-if="
              postArrangementByContactIDAndCategory(
                contact.contactID,
                'Port to location',
              ) &&
              (postArrangementByContactIDAndCategory(
                contact.contactID,
                'Port to location',
              ).postArrangementAction === 'airport' ||
                booking.isGalapagosCruise)
            "
            :postArrangement="
              postArrangementByContactIDAndCategory(contact.contactID, 'Flight')
            "
            tag="div"
            :forms="forms"
          >
            <template
              v-if="postArrangement && !postArrangement.flightBookedByAqua"
              slot-scope="{ postArrangement }"
            >
              <el-row>
                <el-col v-if="booking.recommendedFlight" :span="16">
                  <div class="recommended-flight">
                    <ae-error-wrapper
                      ref="ae-error-wrapper-field"
                      error-message="This is a required field"
                      :is-error="
                        forms[contact.contactID].postArrangements
                          .takingRecommendedFlight
                      "
                    >
                      <template v-slot:form-item>
                        <el-checkbox
                          :value="postArrangement.takingRecommendedFlight"
                          class="check-row"
                          @input="
                            onPostArrangementInputChange(
                              postArrangement.postArrangementID,
                              'takingRecommendedFlight',
                              !postArrangement.takingRecommendedFlight,
                            )
                          "
                        >
                          I am on the recommended flight
                        </el-checkbox>
                      </template>
                    </ae-error-wrapper>
                    <div
                      :class="{
                        hidden: !postArrangement.takingRecommendedFlight,
                      }"
                      class="recommended-flight__detail"
                    >
                      <!-- DepartureDate               2-FEB-18-->
                      <!-- ArrivalDate                 5-FEB-18-->
                      <!-- Ship                        ARIA-->
                      <!-- Nights                      3-->
                      <!-- OutboundFlightFrom          LIM-->
                      <!-- OutboundFlightTo            IQT-->
                      <!-- OutboundFlightCode          LAN2236-->
                      <!-- OutboundFlightDepartureTime 17:35-->
                      <!-- OutboundFlightArrivalTime   19:25-->
                      <!-- ReturnFlightFrom            IQT-->
                      <!-- ReturnFlightTo              LIM-->
                      <!-- ReturnFlightCode            LAN2241-->
                      <!-- ReturnFlightDepartureTime   13:00-->
                      <!-- ReturnFlightArrivalTime     14:45-->

                      <div class="flight__departure">
                        <div class="code">
                          {{ booking.recommendedFlight.returnFlightFrom }}
                        </div>
                        <div class="city">
                          {{ booking.recommendedFlight.returnFlightFromText }}
                        </div>
                        <div class="time">
                          {{
                            booking.recommendedFlight.returnFlightDepartureTime
                          }}
                        </div>
                      </div>

                      <div class="flight__arrival">
                        <div class="code">
                          {{ booking.recommendedFlight.returnFlightTo }}
                        </div>
                        <div class="city">
                          {{ booking.recommendedFlight.returnFlightToText }}
                        </div>
                        <div class="time">
                          {{
                            booking.recommendedFlight.returnFlightArrivalTime
                          }}
                        </div>
                      </div>

                      <div class="flight__number">
                        <div class="label">Flight</div>
                        <div class="value">
                          {{ booking.recommendedFlight.returnFlightCode }}
                        </div>
                      </div>

                      <div class="flight__date">
                        <div class="label">Date</div>
                        <div class="value">
                          {{ booking.recommendedFlight.arrivalDateDisplay }}
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col
                  v-if="postArrangement.takingRecommendedFlight"
                  :span="24"
                  style="margin-top: 24px"
                >
                  My flight reference number is
                  <ae-error-wrapper
                    ref="ae-error-wrapper-field"
                    error-message="This is a required field"
                    :is-error="
                      forms[contact.contactID].postArrangements.referenceNumber
                    "
                  >
                    <template v-slot:form-item>
                      <el-input
                        :value="postArrangement.referenceNumber"
                        placeholder="Flight reference number*"
                        style="width: 240px"
                        @input="
                          onPostArrangementInputChange(
                            postArrangement.postArrangementID,
                            'referenceNumber',
                            $event,
                          )
                        "
                      ></el-input>
                    </template>
                  </ae-error-wrapper>
                  <div class="note" style="margin-top: 16px">
                    <div>
                      Please provide us with your flight reference number in
                      order for us to process the flight check-in for you
                      beforehand.
                    </div>
                    <div>
                      You will find your 6-digit reservation code in the flight
                      confirmation: eg. XXXXXX
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row
                v-if="
                  !booking.recommendedFlight ||
                  !postArrangement.takingRecommendedFlight
                "
                style="margin-top: 24px"
              >
                My departure flight is on
                <ae-error-wrapper
                  ref="ae-error-wrapper-field"
                  error-message="Please enter your post-cruise flight number."
                  :is-error="
                    forms[contact.contactID].postArrangements.flightNumber
                  "
                >
                  <template v-slot:form-item>
                    <el-input
                      :value="postArrangement.flightNumber"
                      placeholder="your flight number*"
                      style="width: auto"
                      @input="
                        onPostArrangementInputChange(
                          postArrangement.postArrangementID,
                          'flightNumber',
                          $event,
                        )
                      "
                    >
                      <template #suffix>
                        <div class="info-flight-number-wrapper">
                          <el-popover
                            content="You will find your flight number in the flight confirmation : eg 'XX 1234' or 'YY 123'."
                            placement="top"
                            trigger="hover"
                            width="200"
                          >
                            <span slot="reference"
                              ><i class="icon icon-information"></i
                            ></span>
                          </el-popover></div
                      ></template>
                    </el-input>
                  </template>
                </ae-error-wrapper>

                on
                <ae-error-wrapper
                  ref="ae-error-wrapper-field"
                  error-message="Please enter the date of your post-cruise arrangements."
                  :is-error="
                    forms[contact.contactID].postArrangements.departureDate
                  "
                >
                  <template v-slot:form-item>
                    <el-date-picker
                      :value="postArrangement.departureDate"
                      format="yyyy-MM-dd"
                      placeholder="Select date*"
                      type="date"
                      value-format="yyyy-MM-dd"
                      @input="
                        onPostArrangementInputChange(
                          postArrangement.postArrangementID,
                          'departureDate',
                          $event,
                        )
                      "
                    />
                  </template>
                </ae-error-wrapper>

                <ae-error-wrapper
                  ref="ae-error-wrapper-field"
                  error-message="Please provide the time of your post-cruise arrangements."
                  :is-error="
                    forms[contact.contactID].postArrangements.departureTime
                  "
                >
                  <template v-slot:form-item>
                    <el-time-picker
                      :value="postArrangement.departureTime"
                      format="HH:mm"
                      placeholder="Select time*"
                      value-format="HH:mm"
                      @input="
                        onPostArrangementInputChange(
                          postArrangement.postArrangementID,
                          'departureTime',
                          $event,
                        )
                      "
                    />
                  </template>
                </ae-error-wrapper>

                <!--<div class="note">You find your flight number in the flight confirmation : eg 'XX 1234' or 'YY 123'.</div>-->
                <br />heading to
                <ae-error-wrapper
                  ref="ae-error-wrapper-field"
                  error-message="This is a required field"
                  :is-error="forms[contact.contactID].postArrangements.to"
                >
                  <template v-slot:form-item>
                    <el-input
                      :value="postArrangement.to"
                      placeholder="place"
                      style="width: auto; margin-top: 24px"
                      @input="
                        onPostArrangementInputChange(
                          postArrangement.postArrangementID,
                          'to',
                          $event,
                        )
                      "
                    />
                  </template>
                </ae-error-wrapper>
              </el-row>
            </template>
          </scope>
          <scope
            v-if="canShowPostArrangementAccommodationField(contact)"
            :postArrangement="
              postArrangementByContactIDAndCategory(
                contact.contactID,
                'Accommodation',
              )
            "
            tag="el-row"
            forms="forms"
          >
            <template v-if="postArrangement" slot-scope="{ postArrangement }">
              <span style="display: inline-block">I will be staying at</span>
              <ae-error-wrapper
                ref="ae-error-wrapper-field"
                error-message="This is a required field"
                :is-error="
                  forms[contact.contactID].postArrangements.accommodationName
                "
              >
                <template v-slot:form-item>
                  <el-input
                    :value="postArrangement.accommodationName"
                    placeholder="name of your accommodation*"
                    style="width: 440px"
                    @input="
                      onPostArrangementInputChange(
                        postArrangement.postArrangementID,
                        'accommodationName',
                        $event,
                      )
                    "
                  />
                </template>
              </ae-error-wrapper>
              <br />
              <div
                v-if="
                  postArrangementByContactIDAndCategory(
                    contact.contactID,
                    'Port to location',
                  ) &&
                  postArrangementByContactIDAndCategory(
                    contact.contactID,
                    'Port to location',
                  ).postArrangementAction === 'sharedTransfer'
                "
                class="note"
              >
                Please indicate "None" if you are not staying in a hotel after
                the voyage.
              </div>
            </template>
          </scope>
          <scope
            v-if="canShowPostArrangementFlightField(contact)"
            :postArrangementFlight="
              postArrangementByContactIDAndCategory(contact.contactID, 'Flight')
            "
            tag="el-row"
            :forms="forms"
          >
            <template
              v-if="postArrangementFlight"
              slot-scope="{ postArrangementFlight }"
            >
              <span style="display: inline-block"
                >My departure flight is on</span
              >
              <ae-error-wrapper
                ref="ae-error-wrapper-field"
                error-message="Please enter your post-cruise flight number."
                :is-error="
                  forms[contact.contactID].postArrangements.flightNumber
                "
              >
                <template v-slot:form-item>
                  <el-input
                    :value="postArrangementFlight.flightNumber"
                    placeholder="your flight number"
                    style="width: auto"
                    @input="
                      onPostArrangementInputChange(
                        postArrangementFlight.postArrangementID,
                        'flightNumber',
                        $event,
                      )
                    "
                  >
                    <template #suffix>
                      <div class="info-flight-number-wrapper">
                        <el-popover
                          content="You will find your flight number in the flight confirmation : eg 'XX 1234' or 'YY 123'."
                          placement="top"
                          trigger="hover"
                          width="200"
                        >
                          <span slot="reference"
                            ><i class="icon icon-information"></i
                          ></span>
                        </el-popover></div
                    ></template>
                  </el-input>
                </template>
              </ae-error-wrapper>

              on
              <ae-error-wrapper
                ref="ae-error-wrapper-field"
                error-message="This is a required field"
                :is-error="
                  forms[contact.contactID].postArrangements.departureDate
                "
              >
                <template v-slot:form-item>
                  <el-date-picker
                    :value="postArrangementFlight.departureDate"
                    format="yyyy-MM-dd"
                    placeholder="Select date*"
                    type="date"
                    value-format="yyyy-MM-dd"
                    @input="
                      onPostArrangementInputChange(
                        postArrangementFlight.postArrangementID,
                        'departureDate',
                        $event,
                      )
                    "
                  />
                </template>
              </ae-error-wrapper>

              <ae-error-wrapper
                ref="ae-error-wrapper-field"
                error-message="This is a required field"
                :is-error="
                  forms[contact.contactID].postArrangements.departureTime
                "
              >
                <template v-slot:form-item>
                  <el-time-picker
                    :value="postArrangementFlight.departureTime"
                    format="HH:mm"
                    placeholder="Select time*"
                    value-format="HH:mm"
                    @input="
                      onPostArrangementInputChange(
                        postArrangementFlight.postArrangementID,
                        'departureTime',
                        $event,
                      )
                    "
                  />
                </template>
              </ae-error-wrapper>

              <div>
                <span style="display: inline-block; margin-top: 24px"
                  ><br />heading to</span
                >
                <ae-error-wrapper
                  ref="ae-error-wrapper-field"
                  error-message="This is a required field"
                  :is-error="forms[contact.contactID].postArrangements.to"
                >
                  <template v-slot:form-item>
                    <el-input
                      :value="postArrangementFlight.to"
                      placeholder="place"
                      style="width: auto"
                      @input="
                        onPostArrangementInputChange(
                          postArrangementFlight.postArrangementID,
                          'to',
                          $event,
                        )
                      "
                    />
                  </template>
                </ae-error-wrapper>
              </div>
            </template>
          </scope>
          <scope
            v-if="canShowDriverDetailsField(contact)"
            :postArrangement="
              postArrangementByContactIDAndCategory(
                contact.contactID,
                'Port to location',
              )
            "
            tag="el-row"
            :forms="forms"
          >
            <template v-if="postArrangement" slot-scope="{ postArrangement }">
              <div style="margin-top: 24px">
                <span
                  :style="{
                    width: 'auto',
                  }"
                  style="display: inline-block"
                  >Driver contact details</span
                >
                <ae-error-wrapper
                  ref="ae-error-wrapper-field"
                  error-message="This is a required field"
                  :is-error="
                    forms[contact.contactID].postArrangements.localHandler
                  "
                >
                  <template v-slot:form-item>
                    <el-input
                      :value="postArrangement.localHandler"
                      placeholder="local handler's name"
                      style="width: auto"
                      @input="
                        onPostArrangementInputChange(
                          postArrangement.postArrangementID,
                          'localHandler',
                          $event,
                        )
                      "
                    ></el-input>
                  </template>
                </ae-error-wrapper>

                <ae-error-wrapper
                  ref="ae-error-wrapper-field"
                  error-message="This is a required field"
                  :is-error="
                    forms[contact.contactID].postArrangements.nameOfPerson
                  "
                >
                  <template v-slot:form-item>
                    <el-input
                      :value="postArrangement.nameOfPerson"
                      placeholder="driver name"
                      style="width: auto"
                      @input="
                        onPostArrangementInputChange(
                          postArrangement.postArrangementID,
                          'nameOfPerson',
                          $event,
                        )
                      "
                    ></el-input>
                  </template>
                </ae-error-wrapper>
                <ae-error-wrapper
                  ref="ae-error-wrapper-field"
                  error-message="This is a required field"
                  :is-error="
                    forms[contact.contactID].postArrangements.contactNo
                  "
                >
                  <template v-slot:form-item>
                    <el-input
                      :value="postArrangement.contactNo"
                      placeholder="contact number"
                      style="width: auto"
                      @input="
                        onPostArrangementInputChange(
                          postArrangement.postArrangementID,
                          'contactNo',
                          $event,
                        )
                      "
                    ></el-input>
                  </template>
                </ae-error-wrapper>
              </div>
            </template>
          </scope>

          <scope
            v-if="booking.isGalapagosCruise"
            :postArrangement="
              postArrangementByContactIDAndCategory(contact.contactID, 'Flight')
            "
            tag="el-row"
          >
            <template
              v-if="
                postArrangement &&
                !postArrangement.flightBookedByAqua &&
                ((postArrangement.flightNumber &&
                  postArrangement.departureDate) ||
                  postArrangement.galapagosRouteInfo)
              "
              slot-scope="{ postArrangement }"
            >
              <div>
                <span> I will be disembarking from </span>

                <ae-error-wrapper
                  ref="ae-error-wrapper-field"
                  error-message="This is a required field"
                  :is-error="
                    forms[contact.contactID].postArrangements.galapagosRouteInfo
                  "
                >
                  <template v-slot:form-item>
                    <!--                    TODO: Validation field map -> EmbarkingFrom: galapagosRouteInfo -->
                    <v-select
                      :ref="'postArrangementTypeSelect' + contact.contactID"
                      :clearable="false"
                      :options="selectTypeOfRouteFromGalapagos"
                      :reduce="(item) => item.value"
                      :searchable="false"
                      :value="postArrangement.galapagosRouteInfo"
                      placeholder="your departure and arrival city*"
                      filterable
                      label="label"
                      style="
                        width: 440px;
                        display: inline-block;
                        vertical-align: middle;
                      "
                      @input="
                        onPostArrangementInputChange(
                          postArrangement.postArrangementID,
                          'galapagosRouteInfo',
                          $event,
                        )
                      "
                      v-on:search:focus="
                        onPostArrangementTypeFocus(contact.contactID)
                      "
                    >
                    </v-select>
                  </template>
                </ae-error-wrapper>
              </div>
            </template>
          </scope>
          <scope
            v-else
            :postArrangement="
              postArrangementByContactIDAndCategory(
                contact.contactID,
                'Port to location',
              )
            "
            tag="el-row"
          >
            <template v-if="postArrangement" slot-scope="{ postArrangement }">
              <div
                v-if="
                  postArrangement.postArrangementAction === 'airport' ||
                  postArrangement.postArrangementAction === 'hotel'
                "
              >
                <div class="arrangement-field">
                  <span
                    v-if="postArrangement.postArrangementAction === 'airport'"
                  >
                    I plan to go to the airport by
                  </span>
                  <span
                    v-else-if="
                      postArrangement.postArrangementAction === 'hotel'
                    "
                  >
                    I plan to go there by
                  </span>

                  <ae-error-wrapper
                    ref="ae-error-wrapper-field"
                    error-message="This is a required field"
                    :is-error="
                      forms[contact.contactID].postArrangements
                        .typeOfPostCruiseArrangement
                    "
                  >
                    <template v-slot:form-item>
                      <v-select
                        :ref="'postArrangementTypeSelect' + contact.contactID"
                        :clearable="false"
                        :options="
                          selectTypeOfArrangementsForPostCruise(contact)
                        "
                        :reduce="(item) => item.value"
                        :searchable="false"
                        :value="postArrangement.typeOfArrangement"
                        placeholder="select option*"
                        filterable
                        label="label"
                        style="
                          width: 440px;
                          display: inline-block;
                          vertical-align: middle;
                        "
                        @input="
                          onPostArrangementInputChange(
                            postArrangement.postArrangementID,
                            'typeOfArrangement',
                            $event,
                          )
                        "
                        v-on:search:focus="
                          onPostArrangementTypeFocus(contact.contactID)
                        "
                      >
                      </v-select>
                    </template>
                  </ae-error-wrapper>
                </div>
                <div
                  v-if="
                    postArrangement.typeOfArrangement &&
                    postArrangement.typeOfArrangement.indexOf(
                      'AE Private transfer',
                    ) === 0 &&
                    booking.postArrangementPrivateTransferLink
                  "
                >
                  <div class="note">
                    Please contact us at
                    <a
                      href="mailto:reservations@aquaexpeditions.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      >reservations@aquaexpeditions.com</a
                    >
                    to arrange your private transfer. Kindly note that this
                    service is available at an additional cost.
                  </div>
                  <!--                  <div class="note">Note: Please refer to the price list and additional information for Aqua Expeditions’ private transfers <a :href="booking.postArrangementPrivateTransferLink" target="_blank">here</a>.</div>-->
                  <div style="margin-top: 16px">
                    Please have the Aqua Expeditions private transfer send me
                    {{
                      postArrangement.postArrangementAction === "airport"
                        ? "to the airport"
                        : "to my accommodation"
                    }}.
                  </div>
                </div>
                <div
                  v-if="postArrangement.typeOfArrangement === 'By 3rd party'"
                  style="margin-top: 24px"
                >
                  <span
                    :style="{
                      width: 'auto',
                    }"
                    style="display: inline-block"
                    >Driver contact details</span
                  >
                  <ae-error-wrapper
                    ref="ae-error-wrapper-field"
                    error-message="This is a required field"
                    :is-error="
                      forms[contact.contactID].postArrangements.localHandler
                    "
                  >
                    <template v-slot:form-item>
                      <el-input
                        :value="postArrangement.localHandler"
                        placeholder="local handler's name*"
                        style="width: auto"
                        @input="
                          onPostArrangementInputChange(
                            postArrangement.postArrangementID,
                            'localHandler',
                            $event,
                          )
                        "
                      ></el-input>
                    </template>
                  </ae-error-wrapper>

                  <ae-error-wrapper
                    ref="ae-error-wrapper-field"
                    error-message="This is a required field"
                    :is-error="
                      forms[contact.contactID].postArrangements.nameOfPerson
                    "
                  >
                    <template v-slot:form-item>
                      <el-input
                        :value="postArrangement.nameOfPerson"
                        placeholder="driver name*"
                        style="width: auto"
                        @input="
                          onPostArrangementInputChange(
                            postArrangement.postArrangementID,
                            'nameOfPerson',
                            $event,
                          )
                        "
                      ></el-input>
                    </template>
                  </ae-error-wrapper>
                  <ae-error-wrapper
                    ref="ae-error-wrapper-field"
                    error-message="This is a required field"
                    :is-error="
                      forms[contact.contactID].postArrangements.contactNo
                    "
                  >
                    <template v-slot:form-item>
                      <el-input
                        :value="postArrangement.contactNo"
                        placeholder="contact number*"
                        style="width: auto"
                        @input="
                          onPostArrangementInputChange(
                            postArrangement.postArrangementID,
                            'contactNo',
                            $event,
                          )
                        "
                      ></el-input>
                    </template>
                  </ae-error-wrapper>
                </div>

                <scope
                  :postArrangementFlight="
                    postArrangementByContactIDAndCategory(
                      contact.contactID,
                      'Flight',
                    )
                  "
                  tag="div"
                  :forms="forms"
                >
                  <template
                    v-if="postArrangementFlight"
                    slot-scope="{ postArrangementFlight }"
                  >
                    <el-row
                      v-if="isSiemReapExtensionBooking()"
                      style="margin-top: 16px"
                    >
                      <ae-error-wrapper
                        ref="ae-error-wrapper-field"
                        error-message="This is a required field"
                        :is-error="
                          forms[contact.contactID].postArrangements
                            .optOutSiemReapExtensionFlight
                        "
                      >
                        <template v-slot:form-item>
                          <el-checkbox
                            :value="
                              postArrangementFlight.optOutSiemReapExtensionFlight
                            "
                            @input="
                              onPostArrangementInputChange(
                                postArrangementFlight.postArrangementID,
                                'optOutSiemReapExtensionFlight',
                                $event,
                              )
                            "
                          >
                            Opt out of Siem Reap flight extension
                          </el-checkbox>
                        </template>
                      </ae-error-wrapper>
                    </el-row>
                  </template>
                </scope>

                <div
                  v-if="
                    postArrangement.typeOfArrangement &&
                    postArrangement.typeOfArrangement.indexOf(
                      'AE Private transfer',
                    ) === 0 &&
                    booking.postArrangementPrivateTransferNote
                  "
                  class="note"
                  v-html="
                    formatTransferNote(
                      booking.postArrangementPrivateTransferNote,
                    )
                  "
                ></div>

                <div
                  v-if="
                    (postArrangement.typeOfArrangement === 'By 3rd party' ||
                      postArrangement.typeOfArrangement === 'Taxi') &&
                    booking.postArrangementOtherTransferNote
                  "
                  class="note"
                >
                  {{ booking.postArrangementOtherTransferNote }}
                </div>
                <div
                  v-if="
                    postArrangement.postArrangementAction === 'airport' &&
                    postArrangement.typeOfArrangement &&
                    postArrangement.typeOfArrangement.indexOf(
                      'AE Private transfer',
                    ) === 0
                  "
                >
                  <el-alert
                    v-if=""
                    :closable="false"
                    show-icon
                    style="margin-bottom: 14px; margin-top: 24px"
                    title="Important note:"
                    type="warning"
                  >
                    <div>
                      Please note that Aqua Expeditions only provides airport
                      transfer immediately after disembarkation.
                    </div>
                  </el-alert>
                </div>
              </div>

              <div
                v-if="
                  (postArrangement.postArrangementAction === 'sharedTransfer' ||
                    postArrangement.typeOfArrangement ===
                      'AE Shared transfer') &&
                  booking.postArrangementSharedTransferNote
                "
                class="note"
                style="margin-top: 32px"
              >
                {{ booking.postArrangementSharedTransferNote }}
              </div>
            </template>
          </scope>
        </div>
        <div
          v-if="booking.isGalapagosCruise"
          class="note"
          style="margin-top: 0"
        >
          All transfers to the airport will be arranged by Aqua Expeditions and
          are shared.
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="sticky-bottom">
      <el-row class="bottom-nav" justify="space-between" type="flex">
        <el-button
          :disabled="isSaving"
          class="button--secondary bottom-nav__secondaryButton"
          @click="onClickBack"
          >Back</el-button
        >
        <autosave-indicator />
        <el-button
          :disabled="isSaving"
          class="button--tertiary bottom-nav__secondaryButton"
          @click="onClickSaveAndExit(false)"
          >Save
        </el-button>
        <el-button
          :disabled="isSaving"
          class="button--primary bottom-nav__primaryButton"
          @click="onClickNext"
          >Proceed to confirmation
        </el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { timeTrack } from "../mixins/timeTrack";
import types from "../store/types";
import contactMixin from "../mixins/contact";
import {
  COUNTRIES,
  FACILITY_CODES,
  PORTS,
  POST_ARRANGEMENT_ACTIONS,
  POST_ARRANGEMENT_ACTIONS_WITHOUT_SHARED_TRANSFER,
  TYPE_OF_ARRANGEMENTS,
  TYPE_OF_ARRANGEMENTS_PRIVATE_AND_THIRD_PARTY,
  TYPE_OF_ARRANGEMENTS_PRIVATE_AND_SHARED_TRANSFER,
  TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_ONLY,
  TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_THIRD_PARTY,
  TYPE_OF_ARRANGEMENTS_WITHOUT_TAXI,
  TYPE_OF_ROUTE_TO_GALAPAGOS,
  TYPE_OF_ROUTE_FROM_GALAPAGOS,
  UNHANDLED_ERROR_MESSAGE,
  GALAPAGOS_FLIGHT_DESTINATION,
  TYPE_OF_ARRANGEMENTS_THIRD_PARTY_ONLY,
  TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER,
  TYPE_OF_ARRANGEMENTS_WITHOUT_PRIVATE_TRANSFER,
  TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_TAXI,
  TYPE_OF_ARRANGEMENTS_THIRD_PARTY_TAXI_AND_OTHER,
  TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI,
  TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_THIRD_PARTY_AND_TAXI,
} from "../constants";
import autosave from "../mixins/autosave";
import AutosaveIndicator from "./AutosaveIndicator";
import {
  delay,
  isCurrentDateBefore,
  positionDropdown,
  waitUntil,
} from "../utils";
import AeErrorWrapper from "./AeErrorWrapper.vue";

export default {
  props: {
    index: Number,
  },
  mixins: [contactMixin, timeTrack, autosave],
  components: { AutosaveIndicator, AeErrorWrapper },
  mounted() {
    // TODO Reenable autosave when repeated flightstats triggering issue is fixed 03/01/2020
    // this.initializeAutosave(this.onClickSaveAndExit.bind(this), this.$refs.formRoot);
    this.clearInvalidArrangementTypes();
  },
  created() {
    gtag("set", "page_path", "/step-4");
    gtag("event", "page_path", {
      path: "/step-4",
    });
  },
  data() {
    const contacts = this.$store.getters["contacts"];
    const booking = this.$store.getters["booking"];
    const contactBookings = this.$store.getters["contactBookings"];

    const formModel = {
      preArrangements: {
        takingRecommendedFlight: false,
        notTakingAFlight: false,
        zanzibarAirport: true,
        otherAirport: false,
        arrivalDate: false,
        arrivalTime: false,
        flightNumber: false,
        from: false,
        airline: false,
        galapagosRouteInfo: false,
        typeOfPreCruiseArrangement: false,
        localHandler: false,
        nameOfPerson: false,
        contactNo: false,
        dateOfEntryToPeru: false,
        entryToPeruFrom: false,
        arrivePriorToCruise: false,
        accommodationName: false,
        daysBefore: false,
        otherMode: false,
      },
      postArrangements: {
        postArrangementAction: false,
        takingRecommendedFlight: false,
        referenceNumber: false,
        flightNumber: false,
        departureDate: false,
        departureTime: false,
        to: false,
        accommodationName: false,
        localHandler: false,
        nameOfPerson: false,
        contactNo: false,
        galapagosRouteInfo: false,
        typeOfPostCruiseArrangement: false,
        optOutSiemReapExtensionFlight: false,
      },
      hasSamePrePostArrangement: false,
    };
    let contactForms = {};
    contacts.forEach((contact) => {
      contactForms[contact.contactID] = structuredClone(formModel);
    });

    return {
      activeCollapseIndexes: this.index
        ? [this.index]
        : contacts.map((contact, index) => index),
      selectCountries: COUNTRIES,
      preCruiseAccommodation: "false",
      forms: contactForms,
      // selectTypeOfArrangementsForPreCruise: booking.isFromPhnomPenh ? TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER : TYPE_OF_ARRANGEMENTS,
      // selectTypeOfArrangementsForPostCruise: TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER,
      // selectPostArrangementActions: booking.isAmazonCruise || booking.isToPhnomPenh ? POST_ARRANGEMENT_ACTIONS_WITHOUT_SHARED_TRANSFER : POST_ARRANGEMENT_ACTIONS,
    };
  },
  computed: {
    ...mapGetters([
      types.getters.preArrangements,
      types.getters.preArrangement,
      types.getters.preArrangementByContactID,
      types.getters.preArrangementByContactIDAndCategory,
      types.getters.postArrangements,
      types.getters.postArrangement,
      types.getters.postArrangementByContactID,
      types.getters.postArrangementByContactIDAndCategory,
      types.getters.contacts,
      types.getters.contact,
      types.getters.contactBooking,
      types.getters.contactBookings,
      types.getters.booking,
      types.getters.primaryContact,
      types.getters.isSaving,
    ]),
    selectTypeOfRouteToGalapagos: function () {
      return TYPE_OF_ROUTE_TO_GALAPAGOS;
    },
    selectTypeOfRouteFromGalapagos: function () {
      return TYPE_OF_ROUTE_FROM_GALAPAGOS;
    },
    selectTypeOfArrangementsForPreCruise: function () {
      return function (contact) {
        if (this.booking.facilityCode === FACILITY_CODES.AquaMekong) {
          if (this.booking.departurePort === PORTS.PhnomPenh) {
            return TYPE_OF_ARRANGEMENTS_PRIVATE_AND_THIRD_PARTY;
          }
          if (this.booking.departurePort === PORTS.SiemReap) {
            return TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_THIRD_PARTY;
          }
          if (this.booking.departurePort === PORTS.HoChiMinh) {
            return TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_THIRD_PARTY;
          }
          return TYPE_OF_ARRANGEMENTS;
        }

        if (this.booking.facilityCode === FACILITY_CODES.AquaBlu) {
          if (this.booking.departurePort === PORTS.Bali) {
            return TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER;
          }
          if (this.booking.departurePort === PORTS.Komodo) {
            return TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_TAXI;
          }
          return TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_ONLY;
        }

        if (this.booking.facilityCode === FACILITY_CODES.AquaMare) {
          return TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_ONLY;
        }

        if (this.booking.facilityCode === FACILITY_CODES.AriaAmazon) {
          return TYPE_OF_ARRANGEMENTS_WITHOUT_TAXI;
        }

        if (this.booking.facilityCode === FACILITY_CODES.AquaNera) {
          return TYPE_OF_ARRANGEMENTS_WITHOUT_TAXI;
        }

        if (this.booking.facilityCode === FACILITY_CODES.AquaLares) {
          if (this.booking.departurePort === PORTS.Seychelles) {
            return TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI;
          }

          if (this.booking.departurePort === PORTS.Tanzania) {
            return TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI;
          }

          if (this.booking.departurePort === PORTS.Longyearbyen) {
            return TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_THIRD_PARTY_AND_TAXI;
          }

          if (this.booking.departurePort === PORTS.Tromso) {
            return TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI;
          }

          if (this.booking.departurePort === PORTS.Glasgow) {
            return TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI;
          }
        }

        return TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI;

        // The following code allows shared transfer for aria amazon cruise only when user select recommended flight
        // if (!this.booking.isAmazonCruise) {
        //   return TYPE_OF_ARRANGEMENTS
        // }
        //
        // const preArrangementFlight = this.preArrangementByContactIDAndCategory(contact.contactID, 'Flight')
        // return preArrangementFlight.takingRecommendedFlight ? TYPE_OF_ARRANGEMENTS : TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER
      };
    },
    selectTypeOfArrangementsForPostCruise: function () {
      return function (contact) {
        if (this.booking.facilityCode === FACILITY_CODES.AquaMekong) {
          if (this.booking.arrivalPort === PORTS.PhnomPenh) {
            return TYPE_OF_ARRANGEMENTS_WITHOUT_TAXI;
          }
          if (
            this.booking.arrivalPort === PORTS.SiemReap ||
            this.booking.arrivalPort === PORTS.HoChiMinh
          ) {
            return TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_THIRD_PARTY;
          }
          return TYPE_OF_ARRANGEMENTS;
        }

        if (this.booking.facilityCode === FACILITY_CODES.AquaBlu) {
          if (this.booking.arrivalPort === PORTS.Bali) {
            return TYPE_OF_ARRANGEMENTS_PRIVATE_AND_THIRD_PARTY;
          }
          if (this.booking.arrivalPort === PORTS.Komodo) {
            return TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_THIRD_PARTY;
          }
          return TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_ONLY;
        }

        if (this.booking.facilityCode === FACILITY_CODES.AquaMare) {
          return TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_ONLY;
        }

        if (this.booking.facilityCode === FACILITY_CODES.AriaAmazon) {
          return TYPE_OF_ARRANGEMENTS_WITHOUT_TAXI;
        }

        if (this.booking.facilityCode === FACILITY_CODES.AquaNera) {
          return TYPE_OF_ARRANGEMENTS_WITHOUT_TAXI;
        }

        if (this.booking.facilityCode === FACILITY_CODES.AquaLares) {
          if (this.booking.arrivalPort === PORTS.Seychelles) {
            return TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI;
          }

          if (this.booking.arrivalPort === PORTS.Tanzania) {
            return TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI;
          }

          if (this.booking.arrivalPort === PORTS.Longyearbyen) {
            return TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_THIRD_PARTY_AND_TAXI;
          }

          if (this.booking.arrivalPort === PORTS.Tromso) {
            return TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI;
          }

          if (this.booking.arrivalPort === PORTS.Glasgow) {
            return TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI;
          }

          return TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI;
        }

        return TYPE_OF_ARRANGEMENTS;

        // The following code allows shared transfer for aria amazon cruise only when user select recommended flight
        // if (!this.booking.isAmazonCruise) {
        //   return TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER
        // }
        //
        // const postArrangementFlight = this.postArrangementByContactIDAndCategory(contact.contactID, 'Flight')
        // return postArrangementFlight.takingRecommendedFlight ? TYPE_OF_ARRANGEMENTS : TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER
      };
    },
    selectPostArrangementActions: function () {
      return function () {
        if (
          this.booking.facilityCode === FACILITY_CODES.AquaBlu ||
          this.booking.facilityCode === FACILITY_CODES.AquaLares ||
          (this.booking.facilityCode === FACILITY_CODES.AquaMekong &&
            this.booking.arrivalPort === PORTS.PhnomPenh)
        ) {
          return POST_ARRANGEMENT_ACTIONS_WITHOUT_SHARED_TRANSFER;
        }
        return POST_ARRANGEMENT_ACTIONS;
      };
    },
  },
  methods: {
    isCurrentDateBefore,
    ...mapActions([
      types.actions.updatePreArrangementField,
      types.actions.updatePostArrangementField,
      types.actions.updatePrePostArrangementsRemote,
      types.actions.updateContactField,
      types.actions.updateContactBookingField,
      types.actions.updateContactsAndBookingRemote,
      types.actions.copyPrePostArrangement,
      types.actions.setIsVisibleDialogSaveAndExit,
    ]),
    // Clears any saved typeOfArrangement values that are no longer in the available
    // options for this ship. This can happen when an option is removed from the
    // arrangement lists (e.g. private transfer removed for AquaLares) but existing
    // bookings still have the old value persisted in the DB. Without this, vue-select
    // would display the stale value on load even though it's not selectable.
    clearInvalidArrangementTypes: function () {
      const validPreValues = this.selectTypeOfArrangementsForPreCruise
        .call(this, null)
        .map((o) => o.value);
      const validPostValues = this.selectTypeOfArrangementsForPostCruise
        .call(this, null)
        .map((o) => o.value);

      this.preArrangements.forEach((preArrangement) => {
        if (
          preArrangement.typeOfArrangement &&
          !validPreValues.includes(preArrangement.typeOfArrangement)
        ) {
          this[types.actions.updatePreArrangementField]({
            preArrangementID: preArrangement.preArrangementID,
            fieldName: "typeOfArrangement",
            value: null,
            triggerReset: true,
          });
        }
      });

      this.postArrangements.forEach((postArrangement) => {
        if (
          postArrangement.typeOfArrangement &&
          !validPostValues.includes(postArrangement.typeOfArrangement)
        ) {
          this[types.actions.updatePostArrangementField]({
            postArrangementID: postArrangement.postArrangementID,
            fieldName: "typeOfArrangement",
            value: null,
            triggerReset: true,
          });
        }
      });
    },
    getGalapagosFlightDestination: function (from) {
      return GALAPAGOS_FLIGHT_DESTINATION[from];
    },
    formatTransferNote(note) {
      if (!note) {
        return "";
      }

      const emails = ["reservations@aquaexpeditions.com"];
      const escapedNote = String(note)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\"/g, "&quot;")
        .replace(/'/g, "&#39;");

      let formattedNote = escapedNote;
      emails.forEach((email) => {
        formattedNote = formattedNote
          .split(email)
          .join(
            `<a href="mailto:${email}" target="_blank" rel="noopener noreferrer">${email}</a>`,
          );
      });

      return formattedNote;
    },
    filterCountry(option, country, query) {
      const index = country.toLowerCase().indexOf(query.toLowerCase());
      if (index === -1) {
        return false;
      }

      if (index === 0) {
        return true;
      }

      const prevChar = country.toLowerCase()[index - 1];
      return prevChar === " ";
    },
    resetFilterCountry(showHide) {
      this.selectCountries = COUNTRIES;
    },
    isSiemReapExtensionBooking() {
      return (
        this.booking.isToPhnomPenh && this.booking.name.indexOf("(ext)") >= 0
      );
    },
    getContactBookingByContactId(contactID) {
      return this.contactBooking(contactID);
    },
    canShowDriverDetailsField: function (contact) {
      return this.isPostArrangementDriverFieldMandatory(contact);
    },
    canShowPostArrangementFlightField: function (contact) {
      return this.isPostArrangementFlightFieldMandatory(contact);
    },
    canShowPostArrangementAccommodationField: function (contact) {
      return this.isPostArrangementAccommodationFieldMandatory(contact);
    },
    canShowPreArrangementAccommodationField: function (contact) {
      return this.isPreArrangementAccommodationFieldMandatory(contact);
      // booking.isAmazonCruise
      // && preArrangementByContactIDAndCategory(contact.contactID, 'Flight')
      // && !preArrangementByContactIDAndCategory(contact.contactID, 'Flight').takingRecommendedFlight;
    },
    canShowDateOfEntryToPeruField: function (contact) {
      return (
        this.booking.isAmazonCruise &&
        contact.mainMailingCountry !== "PE - Peru"
      );
    },
    onCheckHasSamePlan: async function (
      contactID,
      primaryContactID,
      fieldName,
      value,
    ) {
      console.log(
        "onCheckHasSamePlan [contactID, fieldName, value]",
        contactID,
        fieldName,
        value,
      );
      await waitUntil(() => !this.isSaving);
      this[types.actions.updateContactField]({
        contactID,
        fieldName,
        value,
      });

      if (value) {
        const preArrangements = this.preArrangementByContactID(contactID);
        const postArrangements = this.postArrangementByContactID(contactID);
        this[types.actions.copyPrePostArrangement]({
          preArrangements,
          postArrangements,
        });

        // TODO Remove this part after this issue has been fixed in vue-select: https://github.com/sagalbot/vue-select/pull/914
        // Manually update the value in the target vue-selects since there is a bug that prevents the displayed value
        // from being updated when :reduce is used in v-select.
        // if (this.$refs[`preArrangementTypeSelect${primaryContactID}`] && this.$refs[`preArrangementTypeSelect${contactID}`]) {
        //   const preArrangementTypeSourceSelect =  this.$refs[`preArrangementTypeSelect${primaryContactID}`][0];
        //   const preArrangementTypeTargetSelect =  this.$refs[`preArrangementTypeSelect${contactID}`][0];
        //   const option = preArrangementTypeSourceSelect.findOptionFromReducedValue(preArrangementTypeSourceSelect.value)
        //   preArrangementTypeTargetSelect.updateValue(option || null)
        // }
        // if (this.$refs[`postArrangementActionSelect${primaryContactID}`] && this.$refs[`postArrangementActionSelect${contactID}`]) {
        //   const postArrangementActionSourceSelect =  this.$refs[`postArrangementActionSelect${primaryContactID}`][0];
        //   const preArrangementActionTargetSelect =  this.$refs[`postArrangementActionSelect${contactID}`][0];
        //   const option = postArrangementActionSourceSelect.findOptionFromReducedValue(postArrangementActionSourceSelect.value)
        //   preArrangementActionTargetSelect.updateValue(option || null)
        // }
        // if (this.$refs[`postArrangementTypeSelect${primaryContactID}`] && this.$refs[`postArrangementTypeSelect${contactID}`]) {
        //   const postArrangementSourceSelect =  this.$refs[`postArrangementTypeSelect${primaryContactID}`][0];
        //   const postArrangementTargetSelect =  this.$refs[`postArrangementTypeSelect${contactID}`][0];
        //   const option = postArrangementSourceSelect.findOptionFromReducedValue(postArrangementSourceSelect.value)
        //   postArrangementTargetSelect.updateValue(option || null)
        // }
      }
    },
    onPreArrangementInputChange: async function (
      preArrangementID,
      fieldName,
      value,
    ) {
      console.log(
        "[preArrangementID, fieldName, value]",
        preArrangementID,
        fieldName,
        value,
      );
      const preArrangement = this.preArrangement(preArrangementID);
      const previousValue = preArrangement ? preArrangement[fieldName] : null;
      await waitUntil(() => !this.isSaving);
      this[types.actions.updatePreArrangementField]({
        preArrangementID,
        fieldName,
        value,
      });

      if (fieldName === "takingRecommendedFlight") {
        this[types.actions.updatePreArrangementField]({
          preArrangementID,
          fieldName: "flightNumber",
          value: value ? this.booking.recommendedFlight.outboundFlightCode : "",
        });
        this[types.actions.updatePreArrangementField]({
          preArrangementID,
          fieldName: "arrivalDate", // arrivalDate of the outbound flight which is the departureDate of the cruise
          value: value ? this.booking.recommendedFlight.departureDate : "", // this departureDate refers to cruise's departureDate, which is start of the cruise trip
          // recommendedFlight.departureDate refers to preArrangement's arrivalDate
          // recommendedFlight.arrivalDate refers to postArrangement's arrivalDate
        });
        this[types.actions.updatePreArrangementField]({
          preArrangementID,
          fieldName: "arrivalTime",
          value: value
            ? this.booking.recommendedFlight.outboundFlightArrivalTime
            : "",
        });
        this[types.actions.updatePreArrangementField]({
          preArrangementID,
          fieldName: "from",
          value: value ? this.booking.recommendedFlight.outboundFlightFrom : "",
        });
        this[types.actions.updatePreArrangementField]({
          preArrangementID,
          fieldName: "to",
          value: value ? this.booking.recommendedFlight.outboundFlightTo : "",
        });

        // ******
        // * This is no longer applicable as we allow shared transfer even if user unchecks recommended flight for AriaAmazon cruise.
        // ******

        // Special handling for the case where user selects shared transfer and then unchecks recommended flight
        // as shared transfer is only available when taking recommended flight
        // When user does this, unset the shared transfer selection.
        // if (!value) {
        //   const preArrangement = this.preArrangement(preArrangementID)
        //   const contact = this.contact(preArrangement.contactID)
        //   const preArrangementLocationToPort = this.preArrangementByContactIDAndCategory(contact.contactID, 'Location to port')
        //
        //   if (preArrangementLocationToPort && preArrangementLocationToPort.typeOfArrangement === 'AE Shared transfer') {
        //     this[types.actions.updatePreArrangementField]({
        //       preArrangementID: preArrangementLocationToPort.preArrangementID,
        //       fieldName: 'typeOfArrangement',
        //       value: '',
        //     })
        //   }
        // }
      }

      // Compare previous and current value to prevent non-updates from clearing the same prepost arrangement value
      if (value !== previousValue) {
        const contact = this.contact(preArrangement.contactID);
        if (contact.isPrimaryContact) {
          if (fieldName !== "hasSamePrePostArrangement") {
            const contactsToUpdate = this.contacts.filter(
              (contact) =>
                !contact.isPrimaryContact && contact.hasSamePrePostArrangement,
            );
            contactsToUpdate.forEach((contact) => {
              this[types.actions.updateContactField]({
                contactID: contact.contactID,
                fieldName: "hasSamePrePostArrangement",
                value: false,
              });
            });
          }
        } else {
          if (
            fieldName !== "hasSamePrePostArrangement" &&
            contact.hasSamePrePostArrangement
          ) {
            this[types.actions.updateContactField]({
              contactID: contact.contactID,
              fieldName: "hasSamePrePostArrangement",
              value: false,
            });
          }
        }
      }
    },
    onContactBookingInputChange: async function (contactID, fieldName, event) {
      console.log("[contactID, fieldName, event]", contactID, fieldName, event);

      const value = Array.isArray(event) ? event.join(DELIMITER) : event;
      // The user can still edit the field while an autosave is happening,
      // so we should wait until the saving has completed before updating the field again
      await waitUntil(() => !this.isSaving);

      this[types.actions.updateContactBookingField]({
        contactID,
        fieldName,
        value,
      });
    },
    onPostArrangementInputChange: async function (
      postArrangementID,
      fieldName,
      value,
    ) {
      console.log(
        "onPostArrangementInputChange [postArrangementID, fieldName, value]",
        postArrangementID,
        fieldName,
        value,
      );
      const postArrangement = this.postArrangement(postArrangementID);
      const previousValue = postArrangement ? postArrangement[fieldName] : null;
      await waitUntil(() => !this.isSaving);
      this[types.actions.updatePostArrangementField]({
        postArrangementID,
        fieldName,
        value,
        triggerReset: true,
      });

      if (fieldName === "takingRecommendedFlight") {
        this[types.actions.updatePostArrangementField]({
          postArrangementID,
          fieldName: "flightNumber",
          value: value ? this.booking.recommendedFlight.returnFlightCode : "",
        });
        this[types.actions.updatePostArrangementField]({
          postArrangementID,
          fieldName: "departureDate", // departure date of the return flight which is the arrivalDate of the cruise
          value: value ? this.booking.recommendedFlight.arrivalDate : "", // this arrivalDate refers to cruise's arrivalDate which is end of the cruise trip
        });
        this[types.actions.updatePostArrangementField]({
          postArrangementID,
          fieldName: "departureTime",
          value: value
            ? this.booking.recommendedFlight.returnFlightDepartureTime
            : "",
        });
        this[types.actions.updatePostArrangementField]({
          postArrangementID,
          fieldName: "from",
          value: value ? this.booking.recommendedFlight.returnFlightFrom : "",
        });
        this[types.actions.updatePostArrangementField]({
          postArrangementID,
          fieldName: "to",
          value: value ? this.booking.recommendedFlight.returnFlightTo : "",
        });

        // ******
        // * This is no longer applicable as we allow shared transfer even if user unchecks recommended flight for AriaAmazon cruise.
        // ******

        // Special handling for the case where user selects shared transfer and then unchecks recommended flight
        // as shared transfer is only available when taking recommended flight
        // When user does this, unset the shared transfer selection.
        // if (!value) {
        //   const postArrangement = this.postArrangement(postArrangementID)
        //   const contact = this.contact(postArrangement.contactID)
        //   const postArrangementLocationToPort = this.postArrangementByContactIDAndCategory(contact.contactID, 'Port to location')
        //
        //   if (postArrangementLocationToPort && postArrangementLocationToPort.typeOfArrangement === 'AE Shared transfer') {
        //     this[types.actions.updatePostArrangementField]({
        //       postArrangementID: postArrangementLocationToPort.postArrangementID,
        //       fieldName: 'typeOfArrangement',
        //       value: '',
        //     })
        //   }
        // }
      }

      // TODO Remove when vue-select bug is patched (see onCheckHasSamePlan)
      // if (fieldName === 'postArrangementAction') {
      //   // When post arrangement action is changed, the post arrangement type value might be reset.
      //   // We need the v-select to reflect this.
      //   const postArrangementTargetSelect =  this.$refs[`postArrangementTypeSelect${postArrangement.contactID}`][0];
      //   const option = postArrangementTargetSelect.findOptionFromReducedValue(postArrangement.typeOfArrangement)
      //   postArrangementTargetSelect.updateValue(option || null)
      // }

      const contact = this.contact(postArrangement.contactID);
      // Compare previous and current value to prevent non-updates from clearing the same prepost arrangement value
      if (value !== previousValue) {
        if (contact.isPrimaryContact) {
          if (fieldName !== "hasSamePrePostArrangement") {
            const contactsToUpdate = this.contacts.filter(
              (contact) =>
                !contact.isPrimaryContact && contact.hasSamePrePostArrangement,
            );
            contactsToUpdate.forEach((contact) => {
              this[types.actions.updateContactField]({
                contactID: contact.contactID,
                fieldName: "hasSamePrePostArrangement",
                value: false,
              });
            });
          }
        } else {
          if (
            fieldName !== "hasSamePrePostArrangement" &&
            contact.hasSamePrePostArrangement
          ) {
            this[types.actions.updateContactField]({
              contactID: contact.contactID,
              fieldName: "hasSamePrePostArrangement",
              value: false,
            });
          }
        }
      }
    },
    async onPostArrangementTypeFocus(contactID) {
      const select = this.$refs[`postArrangementTypeSelect${contactID}`][0];
      await delay(1);
      const dropdown =
        select.$el.querySelector(".vs__dropdown-menu") ||
        document.querySelector(
          "body > .vs__dropdown-menu:not(.vs__fade-leave-active)",
        );
      if (!dropdown) {
        return;
      }
      positionDropdown(select.$el, dropdown);
      dropdown.style.width = "inherit";
    },
    async onClickSaveAndExit(isAutosaving = false) {
      try {
        const res = await this.saveDataToRemote(isAutosaving);
        if (isAutosaving) {
          return res;
        } else {
          this.setIsVisibleDialogSaveAndExit(true);
        }
      } catch (error) {
        this.$message.error(error.message || UNHANDLED_ERROR_MESSAGE);
        return false;
      }

      return true;
    },
    onClickNext: function () {
      this.saveDataToRemote()
        .then((res) => {
          this.$router.push("step-5");
        })
        .catch((error) => {
          this.$message.error(error.message || UNHANDLED_ERROR_MESSAGE);
        });
    },
    onClickBack: function () {
      this.saveDataToRemote()
        .then((res) => {
          this.$router.back();
        })
        .catch((error) => {
          this.$message.error(error.message || UNHANDLED_ERROR_MESSAGE);
        });
    },
    saveDataToRemote(isAutosave = false) {
      const prePostArrangements = [];
      const { contactBookings } = this;

      this.contacts.forEach((contact) => {
        const preFlight = Object.assign(
          {},
          this.preArrangementByContactIDAndCategory(
            contact.contactID,
            "Flight",
          ),
        );
        const preAccommodation = Object.assign(
          {},
          this.preArrangementByContactIDAndCategory(
            contact.contactID,
            "Accommodation",
          ),
        );
        const preLocationToPort = Object.assign(
          {},
          this.preArrangementByContactIDAndCategory(
            contact.contactID,
            "Location to port",
          ),
        );

        if (preFlight.takingRecommendedFlight) {
          preFlight.from =
            this.booking.recommendedFlight &&
            this.booking.recommendedFlight.outboundFlightFrom
              ? this.booking.recommendedFlight.outboundFlightFrom
              : "";
          preFlight.to =
            this.booking.recommendedFlight &&
            this.booking.recommendedFlight.outboundFlightTo
              ? this.booking.recommendedFlight.outboundFlightTo
              : "";
          preLocationToPort.from = "Airport";
          preLocationToPort.to = "Port";
        }

        if (preLocationToPort.typeOfArrangement === "AE Shared transfer") {
          if (this.booking.isAmazonCruise) {
            preLocationToPort.from = "Airport";
            preLocationToPort.to = "Port";
          } else if (this.booking.isFromVietnamToCambodia) {
            preLocationToPort.from = "The Reverie Hotel";
            preLocationToPort.to = "Port";
          } else if (this.booking.isFromCambodiaToVietnam) {
            preLocationToPort.from = "Park Hyatt Siem Reap Hotel";
            preLocationToPort.to = "Port";
          }
        } else if (preLocationToPort.typeOfArrangement === "By 3rd party") {
          preLocationToPort.to = "Port";
        } else if (preAccommodation.accommodationName) {
          preLocationToPort.from = preAccommodation.accommodationName;
          preLocationToPort.to = "Port";
        }

        const postFlight = Object.assign(
          {},
          this.postArrangementByContactIDAndCategory(
            contact.contactID,
            "Flight",
          ),
        );
        const postAccommodation = Object.assign(
          {},
          this.postArrangementByContactIDAndCategory(
            contact.contactID,
            "Accommodation",
          ),
        );
        const postPortToLocation = Object.assign(
          {},
          this.postArrangementByContactIDAndCategory(
            contact.contactID,
            "Port to location",
          ),
        );

        if (postFlight.takingRecommendedFlight) {
          postFlight.from =
            this.booking.recommendedFlight &&
            this.booking.recommendedFlight.returnFlightFrom
              ? this.booking.recommendedFlight.returnFlightFrom
              : "";
          postFlight.to =
            this.booking.recommendedFlight &&
            this.booking.recommendedFlight.returnFlightTo
              ? this.booking.recommendedFlight.returnFlightTo
              : "";
        }

        if (postPortToLocation.postArrangementAction === "airport") {
          postPortToLocation.from = "Port";
          postPortToLocation.to = "Airport";
        } else if (postPortToLocation.postArrangementAction === "hotel") {
          postPortToLocation.from = "Port";
          postPortToLocation.to = "Accommodation";
        } else if (
          postPortToLocation.postArrangementAction === "sharedTransfer"
        ) {
          if (this.booking.isAmazonCruise) {
            postPortToLocation.from = "Port";
            postPortToLocation.to = "Airport";
          } else if (this.booking.isFromVietnamToCambodia) {
            postPortToLocation.from = "Port";
            postPortToLocation.to = "Park Hyatt Siem Reap Hotel";
          } else if (this.booking.isFromCambodiaToVietnam) {
            postPortToLocation.from = "Port";
            postPortToLocation.to = "The Reverie Hotel";
          }
        }

        prePostArrangements.push(
          preFlight,
          preAccommodation,
          preLocationToPort,
          postFlight,
          postAccommodation,
          postPortToLocation,
        );
      });

      const valid = this.validateForm();
      if (!valid) {
        return Promise.reject({
          message: `Please fill up mandatory fields`,
        });
      }

      // await this.updateContactsAndBookingRemote({contacts: [], booking: {isDirty: false}, contactBookings, showLoader: !isAutosave}); // We only want to update the contact booking
      return this.updatePrePostArrangementsRemote({
        prePostArrangements: prePostArrangements,
        showLoader: !isAutosave,
      });
    },
    resetForm() {
      this.resetFields(this.forms);
    },
    resetFields(form) {
      const topLevelKeys = Object.keys(form);
      topLevelKeys.forEach((topLevelKey) => {
        if (typeof form[topLevelKey] !== "boolean") {
          this.resetChildFields(form[topLevelKey]);
        } else {
          form[topLevelKey] = false;
        }
      });
    },
    resetChildFields(form) {
      this.resetFields(form);
    },
    validateForm() {
      let isValid = true;
      const emptyFieldsFromValidation = this.getTotalProgressData().emptyFields;
      this.resetForm();

      emptyFieldsFromValidation.forEach((emptyFields) => {
        const fieldMap = {
          driverName: "nameOfPerson",
          contactNumber: "contactNo",
        };

        // Remove non step-4 fields
        if (
          emptyFields.preArrangementID === undefined &&
          emptyFields.postArrangementID === undefined
        ) {
          return;
        }

        // Clean the fields
        if (Object.keys(fieldMap).includes(emptyFields.field)) {
          emptyFields.field = fieldMap[emptyFields.field];
        }

        if (
          emptyFields.preArrangementID &&
          this.forms[emptyFields.contactID].preArrangements[
            emptyFields.field
          ] !== undefined
        ) {
          this.forms[emptyFields.contactID].preArrangements[emptyFields.field] =
            true;
          isValid = false;
        } else if (
          emptyFields.postArrangementID &&
          this.forms[emptyFields.contactID].postArrangements[
            emptyFields.field
          ] !== undefined
        ) {
          this.forms[emptyFields.contactID].postArrangements[
            emptyFields.field
          ] = true;
          isValid = false;
        }
      });

      this.scrollToFirstError();

      return isValid;
    },
    scrollToFirstError() {
      // TODO: Might also need to consider unfolding contact collapsable sections if error exist in section
      this.$nextTick(() => {
        // TODO: Edge case not handled
        // Page will scroll to contact 2 empty arrivalTime pre field instead of contact 1 empty flightNumber post field
        const errorWrapperFields = this.$refs["ae-error-wrapper-field"];
        if (errorWrapperFields.length > 0) {
          const errorWrapperFieldsWithErrors = errorWrapperFields.filter(
            (errorWrapperFields) => {
              return errorWrapperFields.$refs["isErrorElement"] !== undefined;
            },
          );

          if (errorWrapperFieldsWithErrors === undefined) {
            return; // Return when no errors found
          }

          const sortedByHighestErrorWrapperFieldsWithErrors =
            errorWrapperFieldsWithErrors.sort((a, b) => {
              if (a === undefined || b === undefined) {
                return 0; // Silently throw error since no DOM element present
              }

              const domElementA = a.$el.getBoundingClientRect();
              const domElementB = b.$el.getBoundingClientRect();
              return domElementA.top - domElementB.top;
            });

          const topMostErrorField =
            sortedByHighestErrorWrapperFieldsWithErrors[0];
          if (topMostErrorField !== undefined) {
            topMostErrorField.$el.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "../scss/color";
@import "../scss/typography";

.main__pre-post-arrangement {
  .el-collapse-item__content {
    border-radius: 0 0 4px 4px;
    border: 1px solid $aqua-grey-75;
    border-width: 0 1px 1px 1px;

    .el-row {
      margin-bottom: 24px;
      @include global-paragraph-medium-regular;
      color: $aqua-grey-100;
    }

    .arrive-by__label {
      @include global-paragraph-small-bold;
      color: $aqua-grey-100;
    }
  }

  .recommended-flight {
    .check-row {
      .el-checkbox__inner {
        vertical-align: middle;
      }

      .el-checkbox__label {
        @include typo(20);
        color: #fff;
        vertical-align: middle;
      }
    }
  }

  .el-input {
    &__inner {
      border: 1px solid $aqua-grey-90;
    }
  }

  .v-select .vs__dropdown-toggle {
    @include typo(20);
    margin: 0 8px;
    border: 1px solid $aqua-grey-90;
  }

  .vs__dropdown-menu {
    margin: 0 8px;
  }

  .arrangement-field {
    display: inline-flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }

  .el-collapse-item--prePostArrangement {
    .el-collapse-item {
      &__header {
        padding-left: 114px;
      }
    }

    .guest-number {
      position: absolute;
      top: 50%;
      left: 40px;
      @include global-paragraph-small-regular;
      transform: translateY(-50%);
    }

    .el-checkbox.checkbox--samePlan {
      position: absolute;
      right: 82px;
      top: 50%;
      transform: translateY(-50%);

      .el-checkbox__input,
      .el-checkbox__input.is-checked {
        & + .el-checkbox__label {
          color: #fff;
        }

        .el-checkbox__inner {
          background-color: #fff;
          border-color: #fff;

          &::after {
            border-color: $primary-color;
          }
        }
      }
    }
  }

  /*.el-collapse-item--prePostArrangement--samePlan {*/
  /*.el-collapse-item__arrow.el-icon-arrow-right::before {*/
  /*display: none;*/
  /*}*/
  /*}*/
}
</style>
<style lang="scss" scoped>
@import "../scss/color";
@import "../scss/typography";

.section-title {
  @include global-paragraph-x-large-bold;
  color: $aqua-grey-100;
}

.note {
  margin-top: 32px;
}

.bold {
  font-weight: bold;
}

.info-flight-number-wrapper {
  display: inline-block;
  width: 24px;
  height: 24px;
  margin: 16px 12px 0 0;
}

.tanzania-flight__other-airport {
  display: flex;
  align-items: center;
}

.tanzania-flight {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
}

.recommended-flight {
  /*width: 750px;*/
  background-image: url("../assets/images/recommended-flight@2x.png");
  background-size: 750px 165px;
  background-repeat: no-repeat;
  border-radius: 4px;

  .check-row {
    display: block;
    padding: 16px 24px 15px 24px;
  }

  &__detail {
    display: flex;
    padding-top: 17px;
    padding-bottom: 17px;
    color: #fff;

    &.hidden {
      display: none;
    }

    .flight {
      &__departure {
        margin-left: 191px;
        text-align: center;
      }

      &__arrival {
        margin-left: 104px;
        text-align: center;
      }

      &__number,
      &__date {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 60px;
      }
    }

    .code {
      @include global-paragraph-x-large-regular;
      font-weight: 900;
    }

    .city {
      font-size: 10px;
      line-height: 12px;
      color: $line-color;
    }

    .time {
      margin-top: 4px;
      @include global-paragraph-medium-bold;
    }

    .label {
      color: rgba(#fff, 0.7);
      @include global-paragraph-small-bold;
    }

    .value {
      @include global-paragraph-medium-bold;
    }
  }
}

.label-mandatory {
  @include global-paragraph-small-regular;
  color: $aqua-grey-75;
}
</style>



// WEBPACK FOOTER //
// src/components/PrePostArrangementPage.vue